import { useMemo } from 'react';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { usePoliceChartsDataContext } from './hooks/usePoliceChartsDataContext';

export const ByCorporateAnual = () => {
    const { chartData } = usePoliceChartsDataContext();

    const { subtitles, series } = useMemo(() => {
        // 1. Sort the items chronologically by year
        const items = (chartData?.byCorporateAnual || [])
            .slice()
            .sort((a, b) => Number(a?.ano_estatistica || 0) - Number(b?.ano_estatistica || 0));

        // 2. Map the X-axis labels (years)
        const subtitles = items.map((item) => getYearLabel(item?.ano_estatistica));

        // 3. Dynamically find all unique corporation names present in the dataset
        const uniqueCorporations = Array.from(
            new Set(
                items.flatMap(item => (item?.corporacoes || []).map(c => c.corporacao))
            )
        );

        // 4. Build the series arrays dynamically based on the found corporations
        const series = uniqueCorporations.map(corpName => ({
            name: corpName,
            data: items.map(item => {
                const corp = (item?.corporacoes || []).find(c => c.corporacao === corpName);
                return Number(corp?.total || 0); // Returns 0 if this specific corp doesn't exist in that year
            })
        }));

        return { subtitles, series };
    }, [chartData]);

    return (
        <SimpleBars
            title="Por Corporação (Anual)"
            horizontal={true}
            subtitles={subtitles}
            series={series}
            height={420}
            showDataLabels={true}
            stacked
        />
    );
};
